import EventsDispatcher from 'controllers/EventsDispatcher.js';
import * as utils from 'controllers/videocall/utils.ts';
import settings from 'controllers/settings';

const awrtc = window.awrtc;

class WebRTCInterface extends EventsDispatcher{
    constructor(defaultLocalVideoParent, defaultRemoteVideoParent) {
        super();
        //awrtc.SLog.SetLogLevel(awrtc.SLogLevel.Info);
        this.mNetConfig = new awrtc.NetworkConfig();
        this.mCall = null;

        this.targetLocalVideoParent = defaultLocalVideoParent;
        this.targetRemoteVideoParent = defaultRemoteVideoParent;

        //update loop
        this.mIntervalId = -1;
        this.mLocalVideo = null;
        this.mRemoteVideo = null;
        this.mIsRunning = false;
        this.mNetConfig.IceServers = [
            { urls: "stun:stun.because-why-not.com:443" },
            { urls: "stun:stun.l.google.com:19302" },
            { urls: "turn:cableo.es:3478", username:"username1", credential: "password1" },
            { urls: "turn:rayman.pixels-hub.com:3478", username:"username1", credential: "password1" }
            
        ];
        this.mNetConfig.IsConference = false;
        this.mNetConfig.SignalingUrl = settings.connections.signalingSocketURL;
        this.connectionID = awrtc.ConnectionId.INVALID;
    }

    async Start(address, audio, video, startingRoom = true) {
        if(audio)
        {
            audio = await utils.mediaDeviceExists("audioinput");
        }
        if(video)
        {
            video = await utils.mediaDeviceExists("videoinput");
        }
        if (this.mCall != null)
            this.Stop();
        this.mIsRunning = true;
        console.log("start");
        console.log("Using signaling server url: " + this.mNetConfig.SignalingUrl);
        //create media configuration
        var config = new awrtc.MediaConfig();
        config.Audio = audio;
        config.Video = video;
        config.IdealWidth = 1920;
        config.IdealHeight = 1080;
        config.MinWidth = 960;
        config.MinHeight = 540;
        config.IdealFps = 30;
        //For usage in HTML set FrameUpdates to false and wait for  MediaUpdate to
        //get the VideoElement. By default awrtc would deliver frames individually
        //for use in Unity WebGL
        console.log("requested config:" + JSON.stringify(config));
        //setup our high level call class.
        this.mCall = new awrtc.BrowserWebRtcCall(this.mNetConfig);
        //handle events (get triggered after Configure / Listen call)
        //+ugly lambda to avoid loosing "this" reference
        this.mCall.addEventListener((sender, args) => {
            this._OnNetworkEvent(sender, args);
        });
        //As the system is designed for realtime graphics we have to call the Update method. Events are only
        //triggered during this Update call!
        this.mIntervalId = setInterval(() => {
            this._Update();
        }, 50);
        //configure media. This will request access to media and can fail if the user doesn't have a proper device or
        //blocks access
        this.mCall.Configure(config);
        //Try to listen to the address 
        //Conference mode = everyone listening will connect to each other
        //Call mode -> If the address is free it will wait for someone else to connect
        //          -> If the address is used then it will fail to listen and then try to connect via Call(address);

        if(startingRoom) this.mCall.Listen(address);
        else this.mCall.Call(address);
    }

    Stop() {
        this._Cleanup();
    }

    _Cleanup() {
        if (this.mCall != null) {
            this.mCall.Dispose();
            this.mCall = null;
            clearInterval(this.mIntervalId);
            this.mIntervalId = -1;
            this.mIsRunning = false;
            this.mLocalVideo = null;
            this.mRemoteVideo = null;
            console.log("cleaning up call");
            this.dispatch("callEnded");
        }
    }
    _Update() {
        if (this.mCall != null)
            this.mCall.Update();
    }

    _OnNetworkEvent(sender, args) {
        //User gave access to requested camera/ microphone
        switch(args.Type)
        {
            case awrtc.CallEventType.CallAccepted:
                console.log("Call accepted");
                this.dispatch("connectionStarted");
                this.connectionID = args.ConnectionId;
                break;
            case awrtc.CallEventType.Invalid:
                console.log("Invalid event");
                break;
            case awrtc.CallEventType.FrameUpdate:
                console.log("Frame update");
                break;
            case awrtc.CallEventType.ConfigurationFailed:
                console.log("Configuration failed");
                break;
            case awrtc.CallEventType.WaitForIncomingCall:
                console.log("connected and waiting for incoming call");
                break;
            case awrtc.CallEventType.ConfigurationComplete:
                console.log("configuration complete");
                break;
            case awrtc.CallEventType.MediaUpdate:
                let margs = args;
                let videoElement = margs.VideoElement;
                videoElement.controls = false;
    
                if (this.mLocalVideo == null && margs.ConnectionId === awrtc.ConnectionId.INVALID)
                {
                    this.mLocalVideo = videoElement;
                    if(!videoElement.videoWidth || !videoElement.videoHeight)
                    {
                        this.mLocalVideo = null;
                        console.log("Local video started with 0 resolution, ignoring");
                        return;
                    }
                    else
                    {
                        this.mLocalVideo = videoElement;
                        if(this.targetLocalVideoParent) this.SetLocalVideoParent(this.targetLocalVideoParent);
                        console.log("local video added resolution:" + videoElement.videoWidth + videoElement.videoHeight);
                    }
                }
                else if (this.mRemoteVideo == null && margs.ConnectionId !== awrtc.ConnectionId.INVALID)
                {
                    if(!videoElement.videoWidth || !videoElement.videoHeight)
                    {
                        this.mRemoteVideo = null;
                        console.log("Remote video started with 0 resolution, ignoring");
                        return;
                    }
                    else
                    {
                        if(videoElement)
                        {
                            videoElement.setAttribute("data-origWidth", videoElement.videoWidth);
                            videoElement.setAttribute("data-origHeight", videoElement.videoHeight);
                            videoElement.removeAttribute("width");
                            videoElement.removeAttribute("height");
                        }
                        this.mRemoteVideo = videoElement;
                        if(this.targetRemoteVideoParent) this.SetRemoteVideoParent(this.targetRemoteVideoParent);
                        console.log("remote video added resolution:" + videoElement.videoWidth + videoElement.videoHeight);
                    }
                }

                this.dispatch("mediaChanged");
                break;
            case awrtc.CallEventType.ListeningFailed:
                // //First attempt of this example is to try to listen on a certain address
                // //for conference calls this should always work (expect the internet is dead)
                // if (!this.mNetConfig.IsConference) {
                //     //no conference call and listening failed? someone might have claimed the address.
                //     //Try to connect to existing call
                //     this.mCall.Call(this.mAddress);
                // }
                // else {
                //     let errorMsg = "Listening failed. Offline? Server dead?";
                //     console.error(errorMsg);
                //     this._RaiseError(errorMsg);
                //     this._Cleanup();
                    
                //     return;
                // }
                break;
            case awrtc.CallEventType.ConnectionFailed:
                //Outgoing call failed entirely. This can mean there is no address to connect to,
                //server is offline, internet is dead, firewall blocked access, ...
                let errorMsg = "Connection failed. Offline? Server dead?";
                this._RaiseError(errorMsg);
                this._Cleanup();
                
                return;
            case awrtc.CallEventType.CallEnded:
                //call ended or was disconnected
                var callEndedEvent = args;
                console.log("call ended with id " + callEndedEvent.ConnectionId.id);
                this.mRemoteVideo = null;
                //check if this was the last user
                if (!this.mNetConfig.IsConference) {
                    //1 to 1 call and only user left -> quit
                    this._Cleanup();
                    
                    return;
                }
                break;
            case awrtc.CallEventType.Message:
                // this shouldn't happen in rayman, only datamessage is being used
                this.dispatch("textMessageReceived", args.Content);
                console.log("mensaje: "+args.Content);
                break;
            case awrtc.CallEventType.DataMessage:
                this.dispatch("dataMessageReceived", args.Content);
                break;
            default: 
                console.log("Unhandled event: " + args.Type);
                console.log(args);
                break;
        }
    }

    SendDataMessage(content, reliable = true)
    {
        this.mCall.Send(content, reliable, this.ConnectionId);

    }

    _Ui_OnCleanup() {
        this.mUiButton.textContent = "Join";
        while (this.mUiLocalVideoParent.hasChildNodes()) {
            this.mUiLocalVideoParent.removeChild(this.mUiLocalVideoParent.firstChild);
        }
        while (this.mUiRemoteVideoParent.hasChildNodes()) {
            this.mUiRemoteVideoParent.removeChild(this.mUiRemoteVideoParent.firstChild);
        }
    }
    _RaiseError(msg) {
        console.error(msg);
        this.dispatch("error", msg);
    }

    // SetLocalVideoParent(element)
    // {
    //     if(!element) return;
    //     this.targetLocalVideoParent = element;
    //     if(!this.mLocalVideo) return;
    //     console.log("Setting local video parent");
    //     console.log(element);
    //     console.log(this.mLocalVideo);
    //     element.appendChild(this.mLocalVideo);
    // }

    // SetRemoteVideoParent(element)
    // {
    //     if(!element) return;
    //     this.targetRemoteVideoParent = element;
    //     if(!this.mRemoteVideo) return;
    //     console.log("Setting remote video parent");
    //     console.log(element);
    //     console.log(this.mRemoteVideo);
    //     element.appendChild(this.mRemoteVideo);
    // }
}

export default WebRTCInterface;